import { useEffect, useState } from "react";
import { FirestoreDocUser } from "breadcommon";
import { AccountsContextProvider } from "./firebaseio/AccountsContext";
import { InstitutionsContextProvider } from "./firebaseio/InstitutionsContext";
import { UserContextProvider } from "./firebaseio/UserContext";
import { CategoriesContextProvider } from "./firebaseio/CategoriesContext";
import { TransactionsContextProvider } from "./firebaseio/TransactionsContext";
import { createContext } from "react";
import { RulesContextProvider } from "./firebaseio/RulesContext";
import { BudgetsContextProvider } from "./firebaseio/BudgetsContext";
import { PreferencesContextProvider } from "./firebaseio/PreferencesContext";
import {
  setInitialPreferences,
  preferencesExists,
} from "./firebaseio/preferencesIo";
import { MainNav } from "./main_nav/MainNav";
import { CategoryGroupsContextProvider } from "./firebaseio/CategoryGroupsContext";
import { PlaidItemsContextProvider } from "./firebaseio/PlaidItemsContext";
import { TagsContextProvider } from "./firebaseio/TagsContext";
import { TransactionsNavProvider } from "./transactions_screen/TransactionsNavProvider";
import { RyeModalAnchor } from "./rye/RyeModal";
import { ExchangeRatesContextProvider } from "./firebaseio/ExchangeRatesContext";

export const LoadingInitialDataContext = createContext<{
  preferences: boolean;
  transactions: boolean;
  accounts: boolean;
  institutions: boolean;
  category_groups: boolean;
  categories: boolean;
  budgets: boolean;
  rules: boolean;
  tags: boolean;
  plaid_items: boolean;
}>({
  preferences: true,
  transactions: true,
  accounts: true,
  institutions: true,
  category_groups: true,
  categories: true,
  budgets: true,
  rules: true,
  tags: true,
  plaid_items: true,
});

export function LoadUser(props: { user: FirestoreDocUser }): JSX.Element {
  const [loadingInitialData, setLoadingInitialData] = useState({
    preferences: true,
    transactions: true,
    accounts: true,
    institutions: true,
    category_groups: true,
    categories: true,
    budgets: true,
    rules: true,
    tags: true,
    plaid_items: true,
  });

  function markInitialLoadComplete(
    dataset: keyof typeof loadingInitialData,
  ): void {
    if (loadingInitialData[dataset]) {
      setLoadingInitialData((loadingInitialData) => {
        return {
          ...loadingInitialData,
          [dataset]: false,
        };
      });
    }
  }

  useEffect(() => {
    const ensurePreferencesExists = async () => {
      const preferencesExistsInFirestore = await preferencesExists(
        props.user.uid,
      );
      if (!preferencesExistsInFirestore) {
        await setInitialPreferences(props.user.uid);
      }
    };
    ensurePreferencesExists();
  }, [props.user.uid]);

  return (
    <LoadingInitialDataContext.Provider value={loadingInitialData}>
      <UserContextProvider user={props.user}>
        <PreferencesContextProvider
          user={props.user}
          markInitialLoadComplete={() => markInitialLoadComplete("preferences")}
        >
          <PlaidItemsContextProvider
            user={props.user}
            markInitialLoadComplete={() =>
              markInitialLoadComplete("plaid_items")
            }
          >
            <TransactionsContextProvider
              user={props.user}
              markInitialLoadComplete={() =>
                markInitialLoadComplete("transactions")
              }
            >
              <AccountsContextProvider
                user={props.user}
                markInitialLoadComplete={() =>
                  markInitialLoadComplete("accounts")
                }
              >
                  <InstitutionsContextProvider
                    user={props.user}
                    markInitialLoadComplete={() =>
                      markInitialLoadComplete("institutions")
                    }
                  >
                  <CategoryGroupsContextProvider
                    user={props.user}
                    markInitialLoadComplete={() =>
                      markInitialLoadComplete("category_groups")
                    }
                  >
                    <CategoriesContextProvider
                      user={props.user}
                      markInitialLoadComplete={() =>
                        markInitialLoadComplete("categories")
                      }
                    >
                      <BudgetsContextProvider
                        user={props.user}
                        markInitialLoadComplete={() =>
                          markInitialLoadComplete("budgets")
                        }
                      >
                        <ExchangeRatesContextProvider>
                          <RulesContextProvider
                            user={props.user}
                            markInitialLoadComplete={() =>
                              markInitialLoadComplete("rules")
                            }
                          >
                            <TagsContextProvider
                              user={props.user}
                              markInitialLoadComplete={() =>
                                markInitialLoadComplete("tags")
                              }
                            >
                              <TransactionsNavProvider>
                                <RyeModalAnchor>
                                  <MainNav />
                                </RyeModalAnchor>
                              </TransactionsNavProvider>
                            </TagsContextProvider>
                          </RulesContextProvider>
                        </ExchangeRatesContextProvider>
                      </BudgetsContextProvider>
                    </CategoriesContextProvider>
                  </CategoryGroupsContextProvider>
                </InstitutionsContextProvider>
            </AccountsContextProvider>
          </TransactionsContextProvider>
          </PlaidItemsContextProvider>
        </PreferencesContextProvider>
      </UserContextProvider>
    </LoadingInitialDataContext.Provider>
  );
}
